import { ForLeaseExclusion } from "../../../../../CoStar/Api/FusionSearch/Migrated/Criteria/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.Space.ForLeaseExclusion */
export { ForLeaseExclusion };
